"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Composition;
exports.getComposition = void 0;

var _where = _interopRequireDefault(require("transmute/where"));

var _ActionTypes = _interopRequireDefault(require("composer-lib/redux/ActionTypes"));

var _Composition = _interopRequireDefault(require("composer-lib/data/model/Composition"));

var _fastJsonPatch = _interopRequireDefault(require("fast-json-patch"));

var _constants = require("composer-lib/lib/constants");

var getComposition = function getComposition(state) {
  return state.composition;
};

exports.getComposition = getComposition;

function getChangedBlocks(body, changes) {
  return changes.filter(function (change) {
    return change.path && change.path.indexOf('/blocks') === 0;
  }).map(function (change) {
    var blockIndex = change.path.split('/')[2];
    var changedBlock = body.blocks ? body.blocks[blockIndex] : null;

    if (changedBlock && changedBlock.key) {
      return changedBlock.key;
    }

    if (change.value && change.value.key) {
      return change.value.key;
    }

    return undefined;
  });
}

function applyRealtimeUpdates(state, action) {
  var _action$data$data$pay = action.data.data.payload,
      body = _action$data$data$pay.body,
      main = _action$data$data$pay.main;
  var composition = state.get('data').toJS();
  var changedBlocks = [];

  try {
    _fastJsonPatch.default.apply(composition, main, true);

    if (body.length) {
      var parsedBody = composition.parsedBody || JSON.parse(composition.body);
      changedBlocks = getChangedBlocks(parsedBody, body);

      _fastJsonPatch.default.apply(parsedBody, body, true);

      composition.parsedBody = parsedBody;
      composition.justUpdated = true;
    }
  } catch (e) {
    window.location.reload();
    return {};
  }

  composition.changedBlocks = changedBlocks;
  return composition;
}

function isSameUpdate(state, action) {
  var main = action.data.data.payload.main;
  var updated = state.updated;
  var matches = (0, _where.default)({
    op: 'replace',
    path: '/updated',
    value: updated
  }, main);
  return matches.length > 0 && matches[0];
} // Get older timestamp between given or now.
// Useful because updated is sometimes slightly ahead returned from server


function getOlderUpdatedOrNow(updated) {
  var now = new Date().valueOf();
  return updated <= now ? updated : now;
}

function Composition() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _Composition.default();
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _ActionTypes.default.FETCH_COMPOSITION_PENDING:
      return state.set('status', _constants.RequestStatus.PENDING);

    case _ActionTypes.default.FETCH_FULL_COMPOSITION_SUCCEEDED:
      return state.mergeFromJS(action.data.composition);

    case _ActionTypes.default.FETCH_COMPOSITION_FAILED:
      return state.set('status', _constants.RequestStatus.FAILED);

    case _ActionTypes.default.REALTIME_UPDATE_COMPOSITION:
      {
        var _action$data = action.data,
            data = _action$data.data,
            userId = _action$data.userId;
        var _data$payload = data.payload,
            body = _data$payload.body,
            main = _data$payload.main;
        var selfLocked = userId === data.authorId;

        if (selfLocked || !(body.length || main.length) || isSameUpdate(state, action)) {
          return state;
        }

        var compositionData = applyRealtimeUpdates(state, action);
        return state.mergeFromJS(compositionData);
      }

    case _ActionTypes.default.END_REALTIME_UPDATE_TRANSITION:
      return state.setIn(['data', 'justUpdated'], false);

    case _ActionTypes.default.SAVE_COMPOSITION_SUCCEEDED:
      return state.set('updated', getOlderUpdatedOrNow(action.data.updated)).setIn(['data', 'metadata'], action.data.metadata);

    case _ActionTypes.default.SET_COMPOSITION_FORCED_READ_ONLY:
      return state.set('forcedReadOnly', action.data);

    default:
      return state;
  }
}